import React from "react";
import { useField } from "formik";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from "@mui/material";

interface FacesSelectorProps {
  name: string;
  label?: string;
  fullWidth?: boolean;
}

const FacesSelector: React.FC<FacesSelectorProps> = ({
  name,
  label = "Número de caras",
  fullWidth = true,
  ...props
}) => {
  const [field, meta] = useField(name);

  return (
    <FormControl
      fullWidth={fullWidth}
      error={meta.touched && Boolean(meta.error)}
      {...props}
    >
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup
        row
        {...field}
        value={field.value || ""}
        onChange={(e) => {
          field.onChange(e);
        }}
        onBlur={field.onBlur}
      >
        <FormControlLabel value="1" control={<Radio />} label="1 cara" />
        <FormControlLabel value="2" control={<Radio />} label="2 caras" />
      </RadioGroup>
      {meta.touched && meta.error ? (
        <FormHelperText>{meta.error}</FormHelperText>
      ) : null}
    </FormControl>
  );
};

export default FacesSelector;

